export default __webpack_public_path__ + "static/media/entete_droite.32515bf5.png";